<template>
  <div v-if="getCurrentDiscussion.enable_grading">
    <div
      v-for="(assessment, index) in studentAssessment"
      :key="index"
      class="mx-3"
    >
      <LiveDiscussionPoint
        class="flex items-center justify-between py-2.5 border-b border-solid border-gray-200"
        @saveAssessment="$emit('saveAssessment', $event)"
        :assessment="assessment"
        :disabled="disabled"
        :pointCap="getCurrentDiscussion.point_cap"
        :is_summary="isSummary"
      />
    </div>
    <div
      v-if="studentAssessment.length"
      class="flex items-center justify-between mx-3 py-2.5 font-medium"
    >
      <span>Total Points</span>
      <span
        class="flex justify-center"
        :class="[hasTeacherPermissionsInCourse ? 'w-20' : 'w-12']"
      >
        <span
          class="flex justify-center items-center h-8 w-12 rounded border border-solid border-gray-200"
        >
          {{ totalPoints }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    props: {
      participation: {
        type: Object,
        default: { user_id: null, rewards: [] },
      },
      isSummary: {
        type: Boolean,
        default: false,
      },
      showEditAssessment: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      LiveDiscussionPoint: require('components/liveDiscussionPointComponent.vue'),
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getCurrentDiscussion',
        'getStudentSummaryLD',
        'getStudentAssessmentsLD',
      ]),
      totalPoints() {
        if (this.getStudentAssessmentsLD.length) {
          return this.getStudentAssessmentsLD
            .map((a) => Number(a.value))
            .reduce((x, y) => x + y);
        }
        return;
      },
      studentAssessment: function () {
        return this.getStudentAssessmentsLD;
      },
    },
  });
</script>



// WEBPACK FOOTER //
// liveDiscussionPointsBar.vue?3710e3be